import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import TaxReturnsTab from './tax/TaxReturnsTab';
import WhtTab from './tax/WhtTab';
import TaxReportsTab from './tax/TaxReportsTab';

const TABS = [
  { value: 'returns', label: 'Tax Returns', Component: TaxReturnsTab },
  { value: 'wht', label: 'Withholding Tax', Component: WhtTab },
  { value: 'reports', label: 'Tax Reports', Component: TaxReportsTab },
];

// Tax & Statutory: filings (VAT/WHT/PAYE/...), withholding certificates and
// remittances, and the statutory VAT/WHT/FX reports (config/ledger.php
// section 'tax'). Setup masters (tax types/rates/codes/exemptions) stay
// under Accounting Settings.
const Tax = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('returns');

  if (!can(RESOURCES.LEDGER.TAX, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Tax &amp; Statutory.</Alert>;
  }

  const Active = TABS.find((t) => t.value === tab)?.Component;

  return (
    <Box>
      <ModulePageHeader
        title="Tax & Statutory"
        subtitle="Tax filings, withholding tax and statutory reports"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs value={tab} onChange={(_, v) => v && setTab(v)} variant="scrollable" scrollButtons="auto">
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {Active && <Active />}
    </Box>
  );
};

export default Tax;